// @flow
import * as React from "react";

type Props = {
  type: React.Node,
  qty: React.Node,
  price: React.Node,
  total: React.Node,

  borders?: boolean,

  style?: { [key: string]: any }
};

const ROW_BORDER = "1px #333 solid";
const CELL_PADDING = "2px 4px";

class DisplayRow extends React.Component<Props> {
  render() {
    const { type, qty, price, total, borders, style } = this.props;

    const borderStyle = borders ? ROW_BORDER : "none";

    return (
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-evenly",
          ...style
        }}
      >
        <div
          style={{
            padding: CELL_PADDING,
            flex: 2,
            borderRight: borderStyle
          }}
        >
          {type}
        </div>
        <div
          style={{
            padding: CELL_PADDING,
            flex: 1,
            borderRight: borderStyle
          }}
        >
          {qty}
        </div>
        <div
          style={{
            padding: CELL_PADDING,
            flex: 1,
            borderRight: borderStyle
          }}
        >
          {price}
        </div>
        <div style={{ padding: CELL_PADDING, flex: 1 }}>{total}</div>
      </div>
    );
  }
}

export default DisplayRow;



// WEBPACK FOOTER //
// ./src/NosBouteilles/DisplayRow.js